import { Moment } from 'moment-timezone';
import { AgreementSignature } from 'types/Agreement';
import { AvailabilityHour } from 'types/Availability';
import { Customer } from 'types/Customer';
import { OnlineBookingItem, OnlineBookingStep, OnlineBookingTime } from 'types/OnlineBooking';
import { Pet } from 'types/Pet';
import { Staff } from 'types/Staff';

export interface OnlineBookingState {
    count: number;
    loading: boolean;
    step: OnlineBookingStep;
    status: OnlineBookingStatus;

    staffs: Array<{
        staff: Staff;
        loading: boolean;
        fetched: boolean;
        busyForWeeks?: number;
        nextAvailableAt?: {
            date: Moment;
            hours: Array<AvailabilityHour>;
        };
    }>;

    availability: Array<AvailabilityHour>;

    pets: Array<Pet>;

    date?: Moment;
    time?: OnlineBookingTime;
    selectedStaffId: number | null;

    agreementSignatures: Array<AgreementSignature>;

    bookingItems: Array<OnlineBookingItem>;

    customer: Customer;
    isReturningClient: boolean;
}

export enum OnlineBookingStatus {
    Initial,

    UpdatePet,
    UpdatePetSuccess,

    Error
}
